import { cacheOnce } from '@koob/utils';
import { get } from '.';

export const getLanguages = cacheOnce(() => get(`/api/v1/languages`));
